module.exports = __webpack_public_path__ + "static/media/metrocorp-grey-old.44b3de7e.svg";